export { default } from "~/components/ui/BannerCarousel";

export const eager = true;
export const sync = true;

export const cache = "listing";

export function LoadingFallback() {
  return (
    <div className="w-full py-8">
      <div className="container mx-auto px-4">
        <div className="h-6 w-48 bg-base-200 animate-pulse rounded mb-4" />
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {Array.from({ length: 4 }).map((_, i) => (
            <div key={i} className="flex flex-col gap-2">
              <div className="aspect-square bg-base-200 animate-pulse rounded" />
              <div className="h-4 bg-base-200 animate-pulse rounded w-3/4" />
              <div className="h-4 bg-base-200 animate-pulse rounded w-1/2" />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
